import { render, staticRenderFns } from "./VCrudCard.vue?vue&type=template&id=0d825a36"
import script from "./VCrudCard.vue?vue&type=script&lang=js"
export * from "./VCrudCard.vue?vue&type=script&lang=js"
import style0 from "./VCrudCard.vue?vue&type=style&index=0&id=0d825a36&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports